import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (config.method === 'get') {
      config.data = true
      config.headers['Content-type'] = 'application/x-www-form-urlencoded'
    }

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['X-Token'] = getToken()
      config.headers['Authorization'] = getToken()
    }

    // 系统标识符，主要用于过滤权限使用，有此标识，返回权限时，进显示该系统权限符--需要后端支持
    config.headers['SystemType'] = 'sso'
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data

    // 检查是否为二进制流响应（如excel、pdf等文件下载）
    const contentType = response.headers['content-type'] || ''
    const responseType = response.config && response.config.responseType
    const isBlob = res instanceof Blob ||
                   responseType === 'blob' ||
                   responseType === 'arraybuffer' ||
                   contentType.includes('application/octet-stream') ||
                   contentType.includes('application/vnd.ms-excel') ||
                   contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
                   contentType.includes('application/pdf') ||
                   contentType.includes('application/msword') ||
                   contentType.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document')

    // 如果是二进制流，直接返回，不进行错误处理
    if (isBlob) {
      // 勿对超大 Blob 打印整个 response 对象，否则 DevTools 序列化会极慢（十几 MB PDF 像「卡死」）
      if (process.env.NODE_ENV === 'development') {
        const url = response.config && response.config.url
        console.log('request》》》 blob', url, response.status, res && res.size != null ? res.size + ' bytes' : '')
      }
      return res
    }

    console.log('request》》》', response)

    const code = res.code
    const url = window.location.href
    console.log('request》》》', url)
    // 根据自定义状态码判断请求是否成功，这里以200作为成功的示例，你可以根据实际后端定义修改
    if (res.code != 200) {
      // Message({
      //   message: res.msg,
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      return res
    } else {
      return res
    }

    // console.log(1111111);
    // 处理各种错误状态码情况
    // handleErrorResponse(res);
    // return Promise.reject(new Error(res.msg || '未知错误'));
  },
  error => {
    console.log('reqest.error>>>>>>', error.response)
    const response = error.response
    if (response) {
      const status = response.status
      if (status === 403 || status === 404 || status === 500 || status === 502 || status === 503 || status === 504) {
        handleErrorResponseByStatus(status)
        return Promise.reject(error)
      } else {
        return
      }
    }

    const res = {
      code: 9999,
      msg: '服务器异常，请联系管理员'
    }

    return Promise.reject(error)
    // return res
    // 如果是网络错误等导致没有正常收到响应（error.response为undefined的情况）
    // if (!error.response) {
    //     Message({
    //         message: '网络连接异常，请检查网络设置',
    //         type: 'error',
    //         duration: 5 * 1000
    //     });
    //     return Promise.reject(error);
    // }
    // console.log(error.response,'--------------------');
    // const status = error.response.status;
    // const msgs = error.response.data.msg
    // debugger
    // handleErrorResponseByStatus(status,msgs);
    // return Promise.reject(error.response.data);
  }
)

// 提取出来的根据具体返回数据中的错误码处理错误的函数
function handleErrorResponse(res) {
  const code = res.code

  console.log()
  if (code === '401') {
    // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    if (code === '401' || code === 50008 || code === 50012 || code === 50014) {
      // to re-login
      MessageBox.confirm('你的登录已失效，可重新登录或留在当前页', '未登录', {
        confirmButtonText: '重新登录',
        cancelButtonText: '留在页面',
        type: 'warning'
      }).then(() => {
        store.dispatch('user/resetToken').then(() => {
          location.reload()
        })
      })
    }
  } else {
    const res = response.data
    return res
    Message({
      message: 11111111111111 || '未知错误',
      type: 'error',
      duration: 5 * 1000
    })
  }
}

// 提取出来的根据HTTP状态码处理错误的函数
function handleErrorResponseByStatus(status, msgs) {
  let msg = ''
  switch (status) {
    case 403:
      msg = msgs || '无操作权限，请联系系统管理员'
      break
    case 404:
      msg = msgs || '请求资源不存在，请检查请求地址'
      break
    case 500:
      msg = msgs || '服务器错误，请联系系统管理员'
      break
    case 502:
      msg = msgs || '网关错误，请联系系统管理员'
      break
    case 503:
      msg = msgs || '服务不可用，请稍后再试'
      break
    case 504:
      msg = msgs || '网关超时，请联系系统管理员'
      break
    default:
      msg = msgs || '错误，请联系系统管理员'
  }
  Message({
    message: msg,
    type: 'error',
    duration: 5 * 1000
  })
}

export default service
